import { formatDistance, parseISO } from 'date-fns';
import { utcToZonedTime } from 'date-fns-tz';

export enum TimeZones {
  EuropeLondon = 'Europe/London',
}

export const getDateInSpecificTimezone = (utcDate: Date, timeZone?: TimeZones) =>
  utcToZonedTime(utcDate, timeZone || TimeZones.EuropeLondon);

export const getTimeSince = (time?: string): string => {
  if (!time) {
    return 'N/A';
  }
  return formatDistance(parseISO(time), new Date());
};
